
define('tmpl!core/templates/webidl/exception.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlException\' id=\'idl-def-{{obj.refId}}\'>{{extAttr obj indent true\n}}{{idn indent}}exception <span class=\'idlExceptionID\'>{{obj.id}}</span>{{superclasses obj}} &#123;\n{{{children}}}{{idn indent}}&#125;;</span>\n');});

